export default __webpack_public_path__ + "static/52-773ed398d18beeb71c504c2df21767b1.gif";